import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";
import { AssetViewer$Ada$Compact } from "@/modules/kreate-components/components/AssetViewer$Ada$Compact";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  numEditions: number | undefined;
  listingPrice: number | undefined;
};

export default function SummaryDescription({
  className,
  style,
  numEditions,
  listingPrice,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <span>{"After the tx, there will be "}</span>
      <span className={cx(styles.fontWeight600, styles.colorPrimary)}>{`${
        numEditions ?? EM_DASH
      } editions`}</span>
      <span>{" listed on Kreate ("}</span>
      <AssetViewer$Ada$Compact
        as="span"
        className={cx(styles.fontWeight600, styles.colorBlack)}
        lovelaceAmount={listingPrice}
      />
      <span
        className={cx(styles.fontWeight600, styles.colorBlack)}
      >{`/edition`}</span>
      <span>{`).`}</span>
    </div>
  );
}
